module.exports = __webpack_public_path__ + "static/media/milligazete.5d79d694.svg";